export type PosterItem = {
  id: string;
  title: string;
  year: string;
  genre: string;
  region: string;
  rating: string;
  meta: string;
  desc: string;
  poster: string;
};

export type SeriesItem = PosterItem & {
  episodes: string;
  status: string;
};

export type FeaturedItem = {
  id: string;
  title: string;
  tag: string;
  rating: string;
  desc: string;
  poster: string;
};

export type RankItem = {
  rank: number;
  title: string;
  meta: string;
  score: string;
  trend: string;
};

export type GuideItem = {
  id: string;
  icon: string;
  title: string;
  desc: string;
};

export type FaqItem = {
  id: string;
  q: string;
  a: string;
};

export const navLinks = [
  { id: "top", label: "首页" },
  { id: "featured", label: "热播精选" },
  { id: "movies", label: "电影大全" },
  { id: "series", label: "电视剧片库" },
  { id: "ranking", label: "追剧榜单" },
  { id: "classics", label: "经典老剧" },
  { id: "guide", label: "追剧指南" },
  { id: "faq", label: "常见问题" },
];

export const siteStats = [
  { value: "12,860+", label: "在库影片", icon: "ri-film-line" },
  { value: "3,240+", label: "电视剧集", icon: "ri-tv-2-line" },
  { value: "28", label: "细分类型", note: "类型持续补充", icon: "ri-price-tag-3-line" },
  { value: "每日", label: "资源更新", note: "更新以站点公告为准", icon: "ri-refresh-line" },
];

export const heroPosters = [
  {
    id: "hero-1",
    title: "星海回响",
    tag: "科幻 / 中国大陆",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20film%20poster%20key%20art%20of%20a%20lone%20astronaut%20facing%20a%20giant%20glowing%20ringed%20planet%2C%20deep%20amber%20and%20warm%20gold%20light%20against%20dark%20space%2C%20dramatic%20volumetric%20lighting%2C%20grainy%20film%20texture%2C%20premium%20vertical%20movie%20poster%20composition&width=600&height=900&seq=hero-poster-01&orientation=portrait",
  },
  {
    id: "hero-2",
    title: "长安幻夜录",
    tag: "古装 / 悬疑",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20costume%20drama%20poster%20art%20of%20a%20figure%20in%20flowing%20robes%20walking%20lantern-lit%20moonlit%20palace%20courtyard%2C%20warm%20amber%20lantern%20glow%20and%20deep%20green%20shadow%2C%20misty%20atmosphere%2C%20grainy%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=hero-poster-02&orientation=portrait",
  },
  {
    id: "hero-3",
    title: "迷雾档案",
    tag: "悬疑 / 犯罪",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20poster%20key%20art%20of%20a%20detective%20silhouette%20in%20a%20foggy%20old%20city%20alley%2C%20warm%20amber%20street%20lamp%20glow%20and%20deep%20green%20shadows%2C%20tense%20moody%20lighting%2C%20grainy%20film%20texture%2C%20premium%20vertical%20movie%20poster%20composition&width=600&height=900&seq=hero-poster-03&orientation=portrait",
  },
];

export const editorPicks: FeaturedItem[] = [
  {
    id: "pick-1",
    title: "长夜将尽",
    tag: "悬疑 · 剧集",
    rating: "9.2",
    desc: "一座沿海小城接连发生失踪案，退休刑警与年轻记者循着旧案线索，在夜色里拼凑出被掩埋多年的真相。节奏克制，氛围压迫感十足。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20drama%20poster%20art%20of%20a%20solitary%20figure%20standing%20on%20a%20rain-soaked%20harbor%20pier%20at%20night%2C%20cold%20fog%20and%20warm%20amber%20harbor%20lights%2C%20tense%20atmosphere%2C%20grainy%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=pick-poster-01&orientation=portrait",
  },
  {
    id: "pick-2",
    title: "山河故人志",
    tag: "剧情 · 电影",
    rating: "8.8",
    desc: "三代人跨越四十年的迁徙故事，从山村到城市，把家族记忆织进时代的褶皱里。画面辽阔，情感克制而厚重，适合安静地一口气看完。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20epic%20family%20drama%20poster%20art%20of%20a%20lone%20traveler%20on%20a%20winding%20mountain%20road%20at%20dusk%2C%20warm%20amber%20golden%20light%20and%20deep%20green%20valley%20shadows%2C%20vast%20vista%2C%20grainy%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=pick-poster-02&orientation=portrait",
  },
  {
    id: "pick-3",
    title: "疾风行动",
    tag: "动作 · 电影",
    rating: "8.5",
    desc: "一支特勤小队奉命护送达官证人，中途遭遇精心布置的伏击。全程高密度追逐与近身搏斗，场面调度干净利落，看得人手心冒汗。",
    poster:
      "https://readdy.ai/api/search-image?query=High-energy%20action%20movie%20poster%20art%20of%20a%20special%20forces%20operative%20sprinting%20through%20a%20burning%20city%20street%2C%20warm%20amber%20fire%20glow%20and%20deep%20green%20smoke%20shadows%2C%20dynamic%20motion%2C%20grainy%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=pick-poster-03&orientation=portrait",
  },
  {
    id: "pick-4",
    title: "春日来信",
    tag: "爱情 · 电影",
    rating: "8.3",
    desc: "两座城市之间，一封晚到了十年的信牵起一段旧缘。没有刻意煽情，只有夏日树影和慢慢流动的心事，适合在周末傍晚静静观看。",
    poster:
      "https://readdy.ai/api/search-image?query=Soft%20romantic%20drama%20poster%20art%20of%20a%20young%20couple%20reading%20letters%20under%20blooming%20spring%20trees%2C%20warm%20amber%20afternoon%20sunlight%20and%20deep%20green%20foliage%20shadows%2C%20dreamy%20bokeh%2C%20grainy%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=pick-poster-04&orientation=portrait",
  },
];

export const movieGenres = ["全部", "科幻", "悬疑", "剧情", "动作", "爱情", "喜剧", "动画"];

export const movies: PosterItem[] = [
  {
    id: "m1",
    title: "迷雾轨迹",
    year: "2026",
    genre: "科幻",
    region: "中国大陆",
    rating: "8.7",
    meta: "128分钟 · 科幻 / 悬疑",
    desc: "记忆可以被提取交易的未来，一名技术员在旧档案里发现了不属于任何人的一段记忆。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20thriller%20movie%20poster%20art%20of%20a%20lone%20figure%20surrounded%20by%20floating%20glowing%20memory%20fragments%2C%20warm%20amber%20light%20trails%20and%20deep%20green%20digital%20haze%2C%20futuristic%20mood%2C%20grainy%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=movie-poster-01&orientation=portrait",
  },
  {
    id: "m2",
    title: "深蓝之下",
    year: "2026",
    genre: "悬疑",
    region: "中国大陆",
    rating: "8.4",
    meta: "116分钟 · 悬疑 / 犯罪",
    desc: "深海钻井平台突发事故，七名船员困在密闭空间，有人必须为真相付出代价。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20suspense%20movie%20poster%20art%20of%20divers%20inside%20a%20dark%20deep-sea%20drilling%20platform%20corridor%2C%20warm%20amber%20emergency%20light%20and%20deep%20green%20underwater%20shadow%2C%20claustrophobic%20mood%2C%20grainy%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=movie-poster-02&orientation=portrait",
  },
  {
    id: "m3",
    title: "荒野归途",
    year: "2025",
    genre: "动作",
    region: "中国大陆",
    rating: "8.1",
    meta: "134分钟 · 动作 / 冒险",
    desc: "一名退役向导护送考察队穿越无人区，风暴后只剩他一人带着地图往回走。",
    poster:
      "https://readdy.ai/api/search-image?query=Adventure%20action%20movie%20poster%20art%20of%20a%20lone%20survivor%20crossing%20a%20vast%20windy%20desert%20canyon%2C%20warm%20amber%20sunset%20light%20and%20deep%20green%20rock%20shadows%2C%20epic%20scale%2C%20grainy%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=movie-poster-03&orientation=portrait",
  },
  {
    id: "m4",
    title: "沉默的证人",
    year: "2025",
    genre: "剧情",
    region: "中国大陆",
    rating: "8.9",
    meta: "122分钟 · 剧情 / 法庭",
    desc: "一位从不接受采访的老法医，用一箱泛黄的卷宗回应了三十年前的一桩疑案。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20courtroom%20drama%20movie%20poster%20art%20of%20an%20elderly%20forensic%20doctor%20surrounded%20by%20old%20case%20files%20in%20a%20dim%20room%2C%20warm%20amber%20desk%20lamp%20glow%20and%20deep%20green%20shadow%2C%20somber%20mood%2C%20grainy%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=movie-poster-04&orientation=portrait",
  },
  {
    id: "m5",
    title: "星海回响",
    year: "2026",
    genre: "科幻",
    region: "中国大陆",
    rating: "8.6",
    meta: "146分钟 · 科幻 / 冒险",
    desc: "深空考察船收到一段来自故乡的旧广播，船员必须在返航与任务之间做出选择。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20space%20adventure%20movie%20poster%20art%20of%20a%20deep%20space%20vessel%20passing%20a%20giant%20ringed%20planet%2C%20warm%20amber%20engine%20glow%20and%20deep%20green%20nebula%20shadows%2C%20grand%20scale%2C%20grainy%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=movie-poster-05&orientation=portrait",
  },
  {
    id: "m6",
    title: "春日来信",
    year: "2025",
    genre: "爱情",
    region: "中国大陆",
    rating: "8.3",
    meta: "108分钟 · 爱情 / 剧情",
    desc: "整理旧屋时发现的一叠信件，让两个素未谋面的人开始了一场跨城的对话。",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20romantic%20drama%20movie%20poster%20art%20of%20a%20young%20woman%20reading%20a%20letter%20by%20an%20open%20window%20with%20spring%20blossoms%2C%20warm%20amber%20sunlight%20and%20deep%20green%20foliage%2C%20gentle%20bokeh%2C%20grainy%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=movie-poster-06&orientation=portrait",
  },
  {
    id: "m7",
    title: "笑看风云录",
    year: "2025",
    genre: "喜剧",
    region: "中国大陆",
    rating: "8.0",
    meta: "102分钟 · 喜剧 / 都市",
    desc: "一家濒临倒闭的老茶馆里，一群各怀绝技的街坊把生意做成了社区连续剧。",
    poster:
      "https://readdy.ai/api/search-image?query=Playful%20comedy%20movie%20poster%20art%20of%20colorful%20neighborhood%20characters%20gathered%20in%20a%20cozy%20old%20teahouse%2C%20warm%20amber%20interior%20light%20and%20deep%20green%20plants%2C%20cheerful%20mood%2C%20grainy%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=movie-poster-07&orientation=portrait",
  },
  {
    id: "m8",
    title: "追光少年",
    year: "2026",
    genre: "动画",
    region: "中国大陆",
    rating: "8.5",
    meta: "95分钟 · 动画 / 家庭",
    desc: "小镇少年第一次坐上火车去看海，一路上遇到的人和事，改变了整个夏天。",
    poster:
      "https://readdy.ai/api/search-image?query=Hand-painted%20animated%20family%20film%20poster%20art%20of%20a%20young%20boy%20on%20a%20train%20watching%20a%20giant%20golden%20sunset%20over%20fields%2C%20warm%20amber%20glow%20and%20deep%20green%20hills%2C%20whimsical%20mood%2C%20painterly%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=movie-poster-08&orientation=portrait",
  },
  {
    id: "m9",
    title: "长夜将尽",
    year: "2025",
    genre: "悬疑",
    region: "中国大陆",
    rating: "9.1",
    meta: "118分钟 · 悬疑 / 剧情",
    desc: "旧案重启的那个夜里，所有人都说了谎，包括最先报案的那个人。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20movie%20poster%20art%20of%20a%20rain-soaked%20empty%20city%20street%20with%20a%20single%20walking%20figure%2C%20warm%20amber%20lamplight%20and%20deep%20green%20wet%20shadows%2C%20tense%20mood%2C%20grainy%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=movie-poster-09&orientation=portrait",
  },
  {
    id: "m10",
    title: "逆风而行",
    year: "2026",
    genre: "动作",
    region: "中国大陆",
    rating: "8.2",
    meta: "130分钟 · 动作 / 剧情",
    desc: "退役自行车运动员重返赛场，为的是一份迟到多年的和解。",
    poster:
      "https://readdy.ai/api/search-image?query=Inspiring%20sports%20drama%20movie%20poster%20art%20of%20a%20cyclist%20racing%20up%20a%20mountain%20road%20at%20golden%20hour%2C%20warm%20amber%20light%20and%20deep%20green%20pine%20shadows%2C%20dynamic%20energy%2C%20grainy%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=movie-poster-10&orientation=portrait",
  },
  {
    id: "m11",
    title: "海岛书店",
    year: "2025",
    genre: "剧情",
    region: "中国大陆",
    rating: "8.4",
    meta: "110分钟 · 剧情 / 治愈",
    desc: "一间开在客运码头旁的小书店，见证了无数次离别与重逢。",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20healing%20drama%20movie%20poster%20art%20of%20a%20tiny%20seaside%20bookstore%20by%20a%20quiet%20harbor%2C%20warm%20amber%20lantern%20glow%20and%20deep%20green%20sea%20shadows%2C%20cozy%20tranquil%20mood%2C%20grainy%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=movie-poster-11&orientation=portrait",
  },
  {
    id: "m12",
    title: "云端守望",
    year: "2026",
    genre: "科幻",
    region: "中国大陆",
    rating: "8.8",
    meta: "140分钟 · 科幻 / 灾难",
    desc: "失控的气候卫星环绕地面，一支气象小组必须抢在最后窗口完成重置。",
    poster:
      "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20disaster%20movie%20poster%20art%20of%20a%20satellite%20orbiting%20above%20giant%20storm%20clouds%2C%20warm%20amber%20sunlight%20edge%20and%20deep%20green%20storm%20shadow%2C%20dramatic%20scale%2C%20grainy%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=movie-poster-12&orientation=portrait",
  },
];

export const seriesGenres = ["全部", "悬疑", "古装", "都市", "科幻", "爱情", "年代", "武侠"];

export const series: SeriesItem[] = [
  {
    id: "s1",
    title: "长安幻夜录",
    year: "2026",
    genre: "古装",
    region: "中国大陆",
    rating: "9.0",
    meta: "古装 / 悬疑",
    episodes: "更新至 24 集",
    status: "连载中",
    desc: "以长安城一连串离奇灯会命案为引，铺开一幅盛唐市井与权力暗流交错的长卷。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20costume%20mystery%20drama%20poster%20art%20of%20lantern-lit%20Tang%20dynasty%20street%20at%20night%20with%20a%20robed%20figure%2C%20warm%20amber%20lantern%20glow%20and%20deep%20green%20shadow%2C%20misty%20atmosphere%2C%20grainy%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=series-poster-01&orientation=portrait",
  },
  {
    id: "s2",
    title: "迷雾档案",
    year: "2026",
    genre: "悬疑",
    region: "中国大陆",
    rating: "8.9",
    meta: "悬疑 / 犯罪",
    episodes: "更新至 18 集",
    status: "连载中",
    desc: "档案室管理员与刑警搭档，从一张被涂改的旧卷宗入手，重启尘封多年的连环案。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20drama%20poster%20art%20of%20a%20detective%20pair%20in%20a%20dim%20archive%20room%20full%20of%20old%20files%2C%20warm%20amber%20desk%20lamp%20glow%20and%20deep%20green%20shadow%2C%20tense%20mood%2C%20grainy%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=series-poster-02&orientation=portrait",
  },
  {
    id: "s3",
    title: "都市心跳",
    year: "2025",
    genre: "都市",
    region: "中国大陆",
    rating: "8.3",
    meta: "都市 / 爱情",
    episodes: "全 32 集",
    status: "已完结",
    desc: "三个合租的年轻人，在高楼与地铁之间寻找属于自己的那一盏灯。",
    poster:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20drama%20poster%20art%20of%20three%20young%20friends%20on%20a%20rooftop%20overlooking%20a%20warm-lit%20city%20at%20dusk%2C%20warm%20amber%20sky%20glow%20and%20deep%20green%20rooftop%20plants%2C%20warm%20mood%2C%20grainy%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=series-poster-03&orientation=portrait",
  },
  {
    id: "s4",
    title: "山河少年行",
    year: "2025",
    genre: "武侠",
    region: "中国大陆",
    rating: "8.6",
    meta: "武侠 / 成长",
    episodes: "全 40 集",
    status: "已完结",
    desc: "背负师门旧怨的少年一路南行，在江湖与庙堂之间重新理解「侠」的含义。",
    poster:
      "https://readdy.ai/api/search-image?query=Wuxia%20martial%20arts%20drama%20poster%20art%20of%20a%20young%20swordsman%20standing%20on%20a%20misty%20mountain%20cliff%20at%20dawn%2C%20warm%20amber%20sunrise%20light%20and%20deep%20green%20pine%20shadows%2C%20epic%20mood%2C%20grainy%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=series-poster-04&orientation=portrait",
  },
  {
    id: "s5",
    title: "星辰之下",
    year: "2026",
    genre: "科幻",
    region: "美国",
    rating: "9.1",
    meta: "科幻 / 悬疑",
    episodes: "更新至 9 集",
    status: "连载中",
    desc: "一座沙漠观测站连续收到规律信号，站内七人开始怀疑彼此的身份。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20mystery%20series%20poster%20art%20of%20a%20lone%20desert%20observatory%20dome%20under%20a%20vast%20starry%20sky%2C%20warm%20amber%20interior%20glow%20and%20deep%20green%20night%20shadows%2C%20eerie%20mood%2C%20grainy%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=series-poster-05&orientation=portrait",
  },
  {
    id: "s6",
    title: "首尔恋歌",
    year: "2025",
    genre: "爱情",
    region: "韩国",
    rating: "8.2",
    meta: "爱情 / 都市",
    episodes: "全 16 集",
    status: "已完结",
    desc: "在一家旧唱片店打工的两人，用一张张黑胶记录下了整个冬天的故事。",
    poster:
      "https://readdy.ai/api/search-image?query=Soft%20romance%20drama%20poster%20art%20of%20a%20couple%20browsing%20vinyl%20records%20in%20a%20cozy%20warm-lit%20shop%2C%20warm%20amber%20lamplight%20and%20deep%20green%20leaf%20shadows%2C%20tender%20mood%2C%20grainy%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=series-poster-06&orientation=portrait",
  },
  {
    id: "s7",
    title: "京都事件簿",
    year: "2025",
    genre: "悬疑",
    region: "日本",
    rating: "8.7",
    meta: "悬疑 / 推理",
    episodes: "全 10 集",
    status: "已完结",
    desc: "旧书店老板兼职解决邻里纠纷，每桩小事背后都连着一段被遗忘的往事。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20drama%20poster%20art%20of%20an%20old%20bookshop%20owner%20in%20a%20quiet%20rainy%20alley%20of%20a%20traditional%20town%2C%20warm%20amber%20shop%20glow%20and%20deep%20green%20wet%20shadows%2C%20calm%20mood%2C%20grainy%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=series-poster-07&orientation=portrait",
  },
  {
    id: "s8",
    title: "岁月长河",
    year: "2026",
    genre: "年代",
    region: "中国大陆",
    rating: "9.0",
    meta: "年代 / 家庭",
    episodes: "更新至 30 集",
    status: "连载中",
    desc: "一座北方老工业城市四十年变迁，透过一个普通工人家庭的日常缓缓展开。",
    poster:
      "https://readdy.ai/api/search-image?query=Nostalgic%20period%20family%20drama%20poster%20art%20of%20a%20worker%20family%20on%20a%20factory%20street%20in%20warm%20evening%20light%2C%20warm%20amber%20sunset%20glow%20and%20deep%20green%20tree%20shadows%2C%20warm%20vintage%20mood%2C%20grainy%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=series-poster-08&orientation=portrait",
  },
];

export const rankingMovies: RankItem[] = [
  { rank: 1, title: "星海回响", meta: "科幻 / 2026 · 146分钟", score: "9.3", trend: "持平" },
  { rank: 2, title: "长夜将尽", meta: "悬疑 / 2025 · 118分钟", score: "9.1", trend: "上升 2" },
  { rank: 3, title: "沉默的证人", meta: "剧情 / 2025 · 122分钟", score: "8.9", trend: "上升 1" },
  { rank: 4, title: "云端守望", meta: "科幻 / 2026 · 140分钟", score: "8.8", trend: "新上榜" },
  { rank: 5, title: "迷雾轨迹", meta: "科幻 / 2026 · 128分钟", score: "8.7", trend: "下降 2" },
  { rank: 6, title: "追光少年", meta: "动画 / 2026 · 95分钟", score: "8.5", trend: "持平" },
];

export const rankingSeries: RankItem[] = [
  { rank: 1, title: "星辰之下", meta: "科幻 / 美国 · 更新至9集", score: "9.2", trend: "上升 1" },
  { rank: 2, title: "长安幻夜录", meta: "古装 / 中国大陆 · 更新至24集", score: "9.0", trend: "下降 1" },
  { rank: 3, title: "岁月长河", meta: "年代 / 中国大陆 · 更新至30集", score: "9.0", trend: "持平" },
  { rank: 4, title: "迷雾档案", meta: "悬疑 / 中国大陆 · 更新至18集", score: "8.9", trend: "上升 3" },
  { rank: 5, title: "京都事件簿", meta: "悬疑 / 日本 · 全10集", score: "8.7", trend: "下降 1" },
  { rank: 6, title: "山河少年行", meta: "武侠 / 中国大陆 · 全40集", score: "8.6", trend: "新上榜" },
];

export const rankingTags = [
  { id: "movie", label: "电影榜" },
  { id: "series", label: "电视剧榜" },
];

export const classics: PosterItem[] = [
  {
    id: "c1",
    title: "老街往事",
    year: "1998",
    genre: "年代",
    region: "中国大陆",
    rating: "9.2",
    meta: "1998 · 年代 / 家庭",
    desc: "一条即将拆迁的老街，七户人家，一个夏天的告别。",
    poster:
      "https://readdy.ai/api/search-image?query=Nostalgic%20vintage%20drama%20poster%20art%20of%20a%20quiet%20old%20Chinese%20neighborhood%20street%20in%20summer%2C%20warm%20amber%20afternoon%20light%20and%20deep%20green%20tree%20shadows%2C%20soft%20faded%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=classic-poster-01&orientation=portrait",
  },
  {
    id: "c2",
    title: "江湖夜雨十年灯",
    year: "2001",
    genre: "武侠",
    region: "中国大陆",
    rating: "9.0",
    meta: "2001 · 武侠 / 剧情",
    desc: "两代剑客十年之约，在江湖与家国之间写下各自的答案。",
    poster:
      "https://readdy.ai/api/search-image?query=Classic%20wuxia%20vintage%20poster%20art%20of%20a%20lone%20swordsman%20in%20flowing%20robes%20by%20a%20rainy%20lantern%20in%20the%20mountains%2C%20warm%20amber%20lantern%20glow%20and%20deep%20green%20mist%2C%20aged%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=classic-poster-02&orientation=portrait",
  },
  {
    id: "c3",
    title: "城南旧梦",
    year: "1995",
    genre: "年代",
    region: "中国大陆",
    rating: "8.8",
    meta: "1995 · 年代 / 文艺",
    desc: "一张唱片、一封旧信，串起城南五十年的聚散。",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20vintage%20nostalgic%20poster%20art%20of%20a%20narrow%20southern%20town%20lane%20with%20wooden%20windows%2C%20warm%20amber%20window%20glow%20and%20deep%20green%20moss%20shadows%2C%20aged%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=classic-poster-03&orientation=portrait",
  },
  {
    id: "c4",
    title: "铁血长城",
    year: "2003",
    genre: "战争",
    region: "中国大陆",
    rating: "8.9",
    meta: "2003 · 战争 / 历史",
    desc: "一段被风沙掩埋的边关往事，一群普通人的坚守。",
    poster:
      "https://readdy.ai/api/search-image?query=Epic%20historical%20war%20vintage%20poster%20art%20of%20guards%20on%20an%20ancient%20beacon%20tower%20at%20dusk%2C%20warm%20amber%20dust%20light%20and%20deep%20green%20mountain%20shadows%2C%20gritty%20aged%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=classic-poster-04&orientation=portrait",
  },
  {
    id: "c5",
    title: "我们的小城",
    year: "1990",
    genre: "剧情",
    region: "中国大陆",
    rating: "8.7",
    meta: "1990 · 剧情 / 生活",
    desc: "小城中学的最后一届毕业生，在毕业照里留下了整个时代。",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20drama%20poster%20art%20of%20students%20cycling%20past%20old%20town%20walls%20in%20golden%20light%2C%20warm%20amber%20sun%20glow%20and%20deep%20green%20foliage%20shadows%2C%20aged%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=classic-poster-05&orientation=portrait",
  },
  {
    id: "c6",
    title: "花开彼岸",
    year: "2005",
    genre: "爱情",
    region: "中国大陆",
    rating: "8.6",
    meta: "2005 · 爱情 / 剧情",
    desc: "渡口边的一次告别，成了一生都未寄出的那张明信片。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20vintage%20poster%20art%20of%20a%20lone%20figure%20at%20a%20river%20ferry%20surrounded%20by%20blooming%20flowers%2C%20warm%20amber%20dusk%20light%20and%20deep%20green%20shallows%2C%20soft%20aged%20film%20texture%2C%20premium%20vertical%20poster%20composition&width=600&height=900&seq=classic-poster-06&orientation=portrait",
  },
];

export const guides: GuideItem[] = [
  {
    id: "g1",
    icon: "ri-compass-3-line",
    title: "新手怎么开始追第一步",
    desc: "先定题材再定节奏：想轻松就从喜剧和动画入手，想沉浸就从悬疑或年代剧开始。把想看的先记进收藏，避免开一堆剧却都看不完。",
  },
  {
    id: "g2",
    icon: "ri-filter-3-line",
    title: "用筛选快速缩小选择范围",
    desc: "在「电影大全」里按类型切换，在「电视剧片库」里按地区与类型筛选，几个点击就能把上百部片源收敛到真正想看的十部以内。",
  },
  {
    id: "g3",
    icon: "ri-calendar-check-line",
    title: "连载剧如何安排观看节奏",
    desc: "连载中剧集适合每周固定时间跟新，完结剧更适合周末连刷。片库里的「连载中 / 已完结」标记可以帮你快速判断要不要现在入坑。",
  },
  {
    id: "g4",
    icon: "ri-history-line",
    title: "老剧重温的正确打开方式",
    desc: "经典老剧值得放慢节奏，一次看两三集，留意台词和场景细节。片库中「经典老剧」分区按年代整理，方便按年份往回翻。",
  },
];

export const faqs: FaqItem[] = [
  {
    id: "f1",
    q: "星辰影视片库都收录哪些类型的资源？",
    a: "片库围绕「最新电影、电视剧、热播剧」三类主要片源展开，并按科幻、悬疑、剧情、动作、爱情、喜剧、动画、古装、都市、年代、武侠等细分类型整理，方便按口味快速筛选。",
  },
  {
    id: "f2",
    q: "页面上的「热播剧」和「电影大全」有什么区别？",
    a: "热播精选更偏向编辑挑选的当下热门剧集与影片，着重介绍看点；电影大全则是按类型划分的完整片单，适合先按类型浏览再挑具体片子。",
  },
  {
    id: "f3",
    q: "排行榜是按什么排序的？",
    a: "榜单按站内片库的观众关注度综合排列，分为电影榜和电视剧榜，页面会标注「上升 / 下降 / 新上榜 / 持平」的趋势参考，仅供选择时参考。",
  },
  {
    id: "f4",
    q: "搜索结果和筛选是实时的吗？",
    a: "是的，搜索与类型筛选都只作用于本页已经展示的内容，输入关键字或切换标签，列表会立刻跟着变化，不需要等待加载。",
  },
  {
    id: "f5",
    q: "「连载中」和「已完结」是怎么区分的？",
    a: "连载中指作品仍在持续更新，卡片上会显示当前更新集数；已完结则代表全集已齐，可以在片库里一次看完整部剧集。",
  },
  {
    id: "f6",
    q: "在手机上浏览会不会不方便？",
    a: "页面针对桌面和移动端都做了适配，海报卡片会自动换行排列，筛选标签和搜索框也支持触屏与键盘操作，手机上同样可以顺畅浏览。",
  },
  {
    id: "f7",
    q: "片库内容会持续更新吗？",
    a: "片库以持续更新为目标，新片与热播剧会陆续补充进对应类型。具体更新节奏以站点后续公告为准，本页内容为例示展示。",
  },
  {
    id: "f8",
    q: "找不到想看的片子怎么办？",
    a: "可以先用类型标签缩小范围，再用搜索框输入片名或关键词；如果仍然没有结果，说明该片源暂未收录，可以稍后再回来查看片库更新。",
  },
];